import styled from '@emotion/styled'

export const ProductSettingsColumnWrapper = styled.div`
  position: relative;
`
